import { Injectable } from '@angular/core';
import { NgForage } from 'ngforage';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';

@Injectable({
  providedIn: 'root'
})
export class NgForageTimestampService {
  private readonly EXPIRY_DIFF = 86400000; // 24 hours

  constructor(private ngForage: NgForage) {}

  public async setTimestamps(
    collectionKey: string,
    items: TimestampItem[]
  ): Promise<void> {
    if (StringHelper.isEmpty(collectionKey)) {
      throw new Error('collectionKey must not be empty');
    }
    if (!CollectionHelper.isPopulated(items)) {
      return;
    }
    const storedItems = await this.ngForage.getItem<TimestampItem[]>(
      collectionKey
    );
    const map = new Map<string, TimestampItem>();
    if (CollectionHelper.isPopulated(storedItems)) {
      storedItems.forEach(e => map.set(e.key, e));
    }
    items.forEach(i => map.set(i.key, i));
    const toStore = [...map.values()];
    await this.ngForage.setItem(collectionKey, toStore);
  }

  public async getExpiredItems(
    collectionKey: string
  ): Promise<TimestampItem[]> {
    if (StringHelper.isEmpty(collectionKey)) {
      throw new Error('collectionKey must not be empty');
    }
    const timeStamps = await this.ngForage.getItem<TimestampItem[]>(
      collectionKey
    );
    if (!CollectionHelper.isPopulated(timeStamps)) {
      return [];
    }
    const now = Date.now();
    CollectionHelper.filterInPlace(
      timeStamps,
      i => now - i.timestamp >= this.EXPIRY_DIFF
    );
    return timeStamps;
  }

  public async removeItems(
    collectionKey: string,
    itemKeys: string[]
  ): Promise<void> {
    if (StringHelper.isEmpty(collectionKey)) {
      throw new Error('collectionKey must not be empty');
    }
    if (!CollectionHelper.isPopulated(itemKeys)) {
      return;
    }
    const timeStampItems = await this.ngForage.getItem<TimestampItem[]>(
      collectionKey
    );
    if (!CollectionHelper.isPopulated(timeStampItems)) {
      return;
    }
    CollectionHelper.filterInPlace(
      timeStampItems,
      i => !itemKeys.includes(i.key)
    );
    await this.ngForage.setItem(collectionKey, timeStampItems);
  }
}

interface TimestampItem {
  key: string;
  timestamp: number;
}
